import { useEffect } from 'react';
import { toast, useSonner } from 'sonner';

export const useSonnerErrorDuration = () => {
  const { toasts } = useSonner();

  useEffect(() => {
    toasts.forEach((toastT) => {
      if (toastT.type === 'error' && !toastT.duration) {
        toast.error(toastT.title, { id: toastT.id, duration: Infinity });
      }
    });
  }, [toasts]);
};
